import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const VocabularyEmailCard = ({ vocabulary }) => (
  <Card.Description>
    <FormattedMessage id="vocabulary.email.subject" values={{ subject: vocabulary.email.subject }} />
  </Card.Description>
);

export default VocabularyEmailCard;
